import Vue from 'vue'
// custom component
// service component
import Initialize from '@/usecases/attend/init'
import TokenVerify from '@/usecases/attend/auth/verify'
import SelectOrganizationFetch from '@/usecases/attend/organization/fetch'
import AtttendMemberInitialize from '@/usecases/attend/member'
// models component
import App from '@/models/App'
import ProfileAttend from '@/models/ProfileAttend'
// import ProfileAttend from '@/models/ProfileAttend.js'

const RouterAttend = [
    {
        path: '/',
        name: 'top',
        // component: () => import('@/components/attend/templates/globals/Index'),
        component: () => import('@/components/attend/pages/Login.vue'),
        meta: { attendRequiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (from.path == '/' && !from.name) {
                console.log(
                    'MARITIME7 ATTEND 系列のURLを新しく開いた時（初回）だけの処理'
                )
                Initialize.of().then(() => {
                    next()
                })
            }
            next()
        },
    },
    {
        path: '/login',
        name: 'AttendLogin',
        component: () => import('@/components/attend/pages/Login.vue'),
        meta: { attendRequiresAuth: false },
        beforeEnter: (to, from, next) => {
            console.log('Attend ログイン')
            next()
        },
    },
    {
        path: '/:maritimeId/home',
        name: 'AttendHome',
        component: () => import('@/components/attend/pages/Home'),
        meta: { attendRequiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (from.path == '/' && !from.name) {
                console.log(
                    'MARITIME7 ATTEND HOME系列のURLを新しく開いた時（初回）だけの処理',
                    to,
                    from
                )
                Initialize.of(to.params.maritimeId).then(() => {
                    if (
                        to.matched.some(
                            (record) => record.meta.attendRequiresAuth
                        )
                    ) {
                        TokenVerify.of()
                            .then(() => {
                                AtttendMemberInitialize.of(
                                    ProfileAttend.shipId(),
                                    ProfileAttend.sailorId(),
                                    ProfileAttend.boardingId()
                                )
                                    .then(() => {
                                        next()
                                    })
                                    .catch(() => {
                                        next('/')
                                    })
                            })
                            .catch(() => {
                                next('/')
                            })
                    } else {
                        next()
                    }
                })
            } else {
                if (
                    to.matched.some((record) => record.meta.attendRequiresAuth)
                ) {
                    TokenVerify.of()
                        .then(() => {
                            AtttendMemberInitialize.of(
                                ProfileAttend.shipId(),
                                ProfileAttend.sailorId(),
                                ProfileAttend.boardingId()
                            )
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        })
                        .catch(() => {
                            next('/')
                        })
                } else {
                    next()
                }
            }
        },
    },
    {
        path: '/:maritimeId/log',
        name: 'AttendLog',
        component: () => import('@/components/attend/pages/Log'),
        meta: { attendRequiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (from.path == '/' && !from.name) {
                console.log(
                    'MARITIME7 打刻ログを新しく開いた時（初回）だけの処理'
                )
                Initialize.of(to.params.maritimeId).then(() => {
                    if (
                        to.matched.some(
                            (record) => record.meta.attendRequiresAuth
                        )
                    ) {
                        TokenVerify.of()
                            .then(() => {
                                AtttendMemberInitialize.of(
                                    ProfileAttend.shipId(),
                                    ProfileAttend.sailorId(),
                                    ProfileAttend.boardingId()
                                )
                                    .then(() => {
                                        next()
                                    })
                                    .catch(() => {
                                        next('/')
                                    })
                            })
                            .catch(() => {
                                next('/')
                            })
                    } else {
                        next()
                    }
                })
            } else {
                if (
                    to.matched.some((record) => record.meta.attendRequiresAuth)
                ) {
                    TokenVerify.of()
                        .then(() => {
                            AtttendMemberInitialize.of(
                                ProfileAttend.shipId(),
                                ProfileAttend.sailorId(),
                                ProfileAttend.boardingId()
                            )
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        })
                        .catch(() => {
                            next('/')
                        })
                } else {
                    next()
                }
            }
        },
    },
    {
        path: '/:maritimeId/history',
        name: 'AttendHistory',
        component: () => import('@/components/attend/pages/History'),
        meta: { attendRequiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (from.path == '/' && !from.name) {
                console.log(
                    'MARITIME7 乗船歴URLを新しく開いた時（初回）だけの処理'
                )
                Initialize.of(to.params.maritimeId).then(() => {
                    if (
                        to.matched.some(
                            (record) => record.meta.attendRequiresAuth
                        )
                    ) {
                        TokenVerify.of()
                            .then(() => {
                                AtttendMemberInitialize.of(
                                    ProfileAttend.shipId(),
                                    ProfileAttend.sailorId(),
                                    ProfileAttend.boardingId()
                                )
                                    .then(() => {
                                        next()
                                    })
                                    .catch(() => {
                                        next('/')
                                    })
                            })
                            .catch(() => {
                                next('/')
                            })
                    } else {
                        next()
                    }
                })
            } else {
                if (
                    to.matched.some((record) => record.meta.attendRequiresAuth)
                ) {
                    TokenVerify.of()
                        .then(() => {
                            AtttendMemberInitialize.of(
                                ProfileAttend.shipId(),
                                ProfileAttend.sailorId(),
                                ProfileAttend.boardingId()
                            )
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        })
                        .catch(() => {
                            next('/')
                        })
                } else {
                    next()
                }
            }
        },
    },
    {
        path: '/:maritimeId/setting',
        name: 'AttendSetting',
        component: () => import('@/components/attend/pages/Setting.vue'),
        meta: { attendRequiresAuth: true },
        beforeEnter: (to, from, next) => {
            if (from.path == '/' && !from.name) {
                console.log(
                    'MARITIME7 乗船歴URLを新しく開いた時（初回）だけの処理'
                )
                Initialize.of(to.params.maritimeId).then(() => {
                    if (
                        to.matched.some(
                            (record) => record.meta.attendRequiresAuth
                        )
                    ) {
                        TokenVerify.of()
                            .then(() => {
                                AtttendMemberInitialize.of(
                                    ProfileAttend.shipId(),
                                    ProfileAttend.sailorId(),
                                    ProfileAttend.boardingId()
                                )
                                    .then(() => {
                                        next()
                                    })
                                    .catch(() => {
                                        next('/')
                                    })
                            })
                            .catch(() => {
                                next('/')
                            })
                    } else {
                        next()
                    }
                })
            } else {
                if (
                    to.matched.some((record) => record.meta.attendRequiresAuth)
                ) {
                    TokenVerify.of()
                        .then(() => {
                            AtttendMemberInitialize.of(
                                ProfileAttend.shipId(),
                                ProfileAttend.sailorId(),
                                ProfileAttend.boardingId()
                            )
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        })
                        .catch(() => {
                            next('/')
                        })
                } else {
                    next()
                }
            }
        },
    },
]
export default RouterAttend
